<template>
  <div
    :class="[
      'social-buttons-component',
      {
        'theme-share': theme === 'share',
      },
    ]"
  >
    <div class="buttons">
      <label class="label">
        <slot></slot>
      </label>
      <ul class="solcial-buttons">
        <li
          class="icon-button"
          :key="index"
          v-for="(item, key, index) in socialMediaButtons"
          target="_popup"
        >
          <social-sharing
            :url="location"
            :title="title"
            :description="description"
            v-if="theme === 'share'"
            inline-template
          >
            <network :network="item.network">
              <div>
                <a
                  class="base-button default style-mini"
                  href="/"
                  @click.prevent="() => {}"
                >
                  <span :class="['social-icon', item.icon]"></span>
                </a>
              </div>
            </network>
          </social-sharing>
        </li>
      </ul>
    </div>
    <div class="links">
      <a class="link" href="/" @click.prevent="printClick">Напечатать</a>
      <a class="link" href="/" @click.prevent="copyClick">Скопировать ссылку</a>
    </div>
  </div>
</template>
<script>
import AppData from "../AppData";
import utils from "../utils";

export default {
  name: "ShareWidget",
  props: {
    printId: String,
    shareUrl: String,
    title: String,
    description: String,
    quote: String,
    hashtags: String,
    theme: {
      default: "login",
      type: String,
    },
    textPosition: {
      default: "none",
      type: String,
    },
  },
  data() {
    return {
      socialMediaButtons: AppData.socialMedias,
    };
  },
  computed: {
    location() {
      return window.location.href;
    },
  },
  methods: {
    printClick() {
      this.$htmlToPaper(this.printId, () => {
        console.log("Printing done or got cancelled!");
      });
      //       print();
      //       // Get HTML to print from element
      //       const prtHtml = document.getElementById(this.printId).innerHTML;

      //       // Get all stylesheets HTML
      //       let stylesHtml = "";
      //       for (const node of [
      //         ...document.querySelectorAll('link[rel="stylesheet"], style'),
      //       ]) {
      //         stylesHtml += node.outerHTML;
      //       }

      //       // Open the print window
      //       const WinPrint = window.open(
      //         "",
      //         "",
      //         "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      //       );

      //       WinPrint.document.write(`<!DOCTYPE html>
      // <html>
      //   <head>
      //     ${stylesHtml}
      //   </head>
      //   <body>
      //     ${prtHtml}
      //   </body>
      // </html>`);

      //       WinPrint.document.close();
      //       WinPrint.focus();
      //       WinPrint.print();
      //       WinPrint.close();
    },
    copyClick() {
      utils.copyToClipboard(window.location.href);
    },
  },
};
</script>

<style lang="scss">
$share-icon-color: rgba(29, 29, 27, 0.5);
$share-icon-font-size: 10px;
$share-size: 24px;

.social-buttons-component {
  display: grid;
  grid-gap: 22px;
  grid-auto-flow: row;

  // { icon: 'icon-facebook', href: '/', },
  // { icon: 'icon-vk', href: '/', },
  // { icon: 'icon-odnoklassniki', href: '/', },
  // { icon: 'icon-telegram', href: '/', },
  .icon-odnoklassniki::before {
    font-size: 13px !important;
  }
  ul.solcial-buttons {
    padding: 0;
    margin: 0;
    display: grid;
    grid-auto-flow: column;
    justify-content: flex-start;
    grid-gap: 22px;
    list-style-type: none;
    li.icon-button {
      > span {
        outline: none !important;
      }
      padding: 0;
      margin: 0;
    }
  }
  &.theme-share {
    grid-auto-flow: column;
    justify-content: flex-start;
    align-items: center;
    .label {
      @extend %text-h5;
      color: $text-main-quart;
    }
    .solcial-buttons {
      @media all and (max-width: $md) {
        grid-row: 1;
        grid-column: 2;
        grid-gap: 10px;
      }
      grid-gap: 17px;
    }
    .social-icon {
      &::before {
        transition: color 0.5s;
        font-size: $share-icon-font-size;
        color: $share-icon-color;
        line-height: 35px;
        position: relative;
      }
    }
    .base-button {
      &:hover {
        .social-icon {
          &::before {
            color: $text-inverse-main;
          }
        }
      }
    }
    .icon-vkontakte::before {
      font-size: 8px;
    }
    .base-button.style-mini {
      @extend %button;
      border-bottom: 0;

      width: $share-size;
      height: $share-size;
      border-radius: 50%;
      display: grid;
      justify-items: center;
      align-items: center;
    }
  }
  .links {
    @media all and (max-width: $md) {
      grid-row: 2;
      grid-column: 1 / span 2;
      grid-auto-flow: column;
    }
    grid-auto-flow: column;
    display: grid;
    grid-gap: 22px;
    .link {
      @extend %text-h5;
      color: $text-main-quart;
      border-color: transparent;
    }
  }
  .buttons {
    grid-auto-flow: column;
    @media all and (max-width: $md) {
      grid-row: 1;
      grid-column: 1 / span 2;
      grid-auto-flow: column;
    }
    justify-content: flex-start;
    justify-items: flex-start;
    align-items: center;
    display: grid;
    grid-gap: 12px;
  }
}
</style>
